import React, { useState } from 'react';
import Header from '../header/Header';
import { LayoutContainer, Body } from './style';
import SpLoader from '../../../components/atoms/SpLoader';
import { withSnackbar } from '../../../components/atoms/SpSnackBar';
import './layout.css';

const Layout = (props, base) => {
  const [loading, isLoading] = useState(false);

  return (
    <LayoutContainer>
      <Header userAdmin={props?.userAdmin} />
      <Body>
        {loading && <SpLoader />}
        {React.Children.map(props.children, (child, index) => {
          return React.cloneElement(child, {
            isLoading: isLoading
          });
        })}
      </Body>
    </LayoutContainer>
  );
};

export default withSnackbar(Layout);
